import React, { ReactNode } from "react";
import style from "./LoginFinish.module.scss";

type Props = {
  children: ReactNode;
};

export const LoaderContainer: React.FC<Props> = ({ children }) => {
  return <div className={style.loaderContainer}>{children}</div>;
};

export const Loader: React.FC = () => {
  return <div className={style.loaderHourGlass} />;
};
